import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
	selector: 'app-account',
	templateUrl: './account.component.html',
	styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {
	modalRef: BsModalRef;
	searchobj: any = {
		searchAddress: ''
	}
	token = localStorage.getItem('Sastana_Token');
	userAcc: any; userAddress; qrimage; userBal;
	@ViewChild('receive') receive: TemplateRef<any>;
	transactionList: any;
	accountList: any;
	account: number = 1
	yesterDayaccountGrowth: any;
	Holders: any;
	totalAccounts: any
	dailyActiveaccounts: any;

	constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private modalService: BsModalService, private spinner: NgxSpinnerService) { }

	ngOnInit() {
		setTimeout(() => {
			this.getTestData()
			this.transactionHistory();
			this.yesterDayaccountCounts();
			this.totalAccountsdetails()
			this.activeAccounts()
		}, 1000)
	}

	getAccounts() {
		this.route.navigate(['pages/account-chart'])
	}

	activeAccounts() {
		this.conn.postUrl('users/activeAccount', {}).subscribe((res: any) => {
			this.dailyActiveaccounts = res.data
		})
	}

	copyText(val: string) {
		let selBox = document.createElement('input');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		this.alert.success('Copied to the clipboard');
	}

	reciveModal() {
		this.modalRef = this.modalService.show(this.receive);
	}


	yesterDayaccountCounts() {
		this.conn.postUrl('users/24hrAccounts', {}).subscribe((res: any) => {
			this.yesterDayaccountGrowth = res.transData
		})
	}

	totalAccountsdetails() {
		this.conn.postUrl('users/dashboard-data', {}).subscribe((res: any) => {
			this.totalAccounts = res.data[0].totalAccounts
		})
	}

	transactionHistory() {
		this.conn.postUrl('users/userList', {}).subscribe((res: any) => {
			this.spinner.show()
			if (res.success == true) {
				this.spinner.hide()
				this.accountList = res.data
			}
		})
	}

	getTestData() {
		this.conn.postUrl('users/sastHoldCount', {}).subscribe((res: any) => {
			this.Holders = res.data
		})
	}
}

